import { Dialog } from './dialog';

export class HelpDialog extends Dialog {
    constructor(app) {
        super(app.container.select('#sd-help-dialog'), app);
    }
}
